import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPhone,FiMail}=FiIcons;

const MobileCTA=()=> {
  return (
    // Increased z-index to z-[999] - AUFGEHOBEN: Mobile CTA komplett ausgeblendet
    <div className="fixed bottom-0 left-0 right-0 z-[999] bg-white border-t border-gray-200 p-4 md:hidden hidden">
      <div className="flex space-x-3">
        <a 
          href="tel:+4924528607019" 
          className="flex-1 bg-[#3466ad] text-white py-3 rounded-lg font-medium text-center flex items-center justify-center space-x-2 hover:bg-[#2a5291] transition-colors"
        >
          <SafeIcon icon={FiPhone} className="w-4 h-4" />
          <span>Anrufen</span>
        </a>
        <Link 
          to="/kontakt" 
          className="flex-1 border-2 border-[#3466ad] text-[#3466ad] py-3 rounded-lg font-medium text-center flex items-center justify-center space-x-2 hover:bg-[#3466ad] hover:text-white transition-colors"
        >
          <SafeIcon icon={FiMail} className="w-4 h-4" />
          <span>Kontakt</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileCTA;